import {CameraControls } from "@react-three/drei"
import { useEffect,useRef } from "react"
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function MyCamera(){

    const ref = useRef()
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  


    return(
        <CameraControls  ref={ref} minDistance={3} maxDistance={isMobile ? 17.5 : 11.5} maxPolarAngle={Math.PI / 2.1}/>

    )
}